<template>
  <svg viewBox="0 0 16 16" fill="inherit" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.47027 4L5.53027 4.94L8.58361 8L5.53027 11.06L6.47027 12L10.4703 8L6.47027 4Z"/>
  </svg>
</template>
<script setup lang="ts">
</script>